import { NgModule } from "@angular/core";
import { sharedModule } from "src/app/shared/shared.module";
import { RegistrationComponent } from "./registration.component";
import { AddRegistrationComponent } from "./add-registration/add-registration.component";
import { ConfirmRegistrationEntryComponent } from "./confirm-registration-entry/confirm-registration-entry.component";
import { DirectRegisterComponent } from './direct-register/direct-register.component';
import { AngularTiltModule } from "angular-tilt";

@NgModule({
  declarations: [
    RegistrationComponent,
    AddRegistrationComponent,
    ConfirmRegistrationEntryComponent,
    DirectRegisterComponent
  ],
  imports: [sharedModule,AngularTiltModule],
  entryComponents: [ConfirmRegistrationEntryComponent, DirectRegisterComponent]
})
export class registrationModule {}
